import { gql } from '@apollo/client';

// Simple query to get all customer payment methods
// To determine which payment method is selected for a campaign,
// query the campaign's campaignPaymentMethods separately
export const GET_CUSTOMER_PAYMENT_METHODS = gql`
  query GetCustomerPaymentMethods {
    customerPaymentMethodsForCustomer {
      id
      fullName
      address
      city
      state
      zip
      lastFour
      expMonth
      expYear
      defaultPaymentMethod
      billingType {
        typeName
      }
      processor {
        typeName
      }
    }
  }
`;

